import React, { Component } from 'react';

const SHOW_AFTER = 400; // px: после какой прокрутки вниз показывать кнопку

/**
 * Круглая кнопка «наверх» (справа-снизу).
 * Появляется, когда пользователь прокрутил контент вниз, и плавно возвращает
 * экран к началу по клику. Скролл-контейнер сайта — #root (см. src/ver2/index.jsx),
 * на случай если #root не скроллится — слушаем и window.
 */
export default class ScrollTopButton extends Component {
    state = {
        visible: false,
    }

    componentDidMount() {
        const scroller = document.getElementById('root');
        if (scroller) scroller.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
    }

    componentWillUnmount() {
        const scroller = document.getElementById('root');
        if (scroller) scroller.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('scroll', this.onScroll);
    }

    getScrollTop = () => {
        const scroller = document.getElementById('root');
        return scroller ? scroller.scrollTop : (window.scrollY || window.pageYOffset || 0);
    }

    onScroll = () => {
        const visible = this.getScrollTop() > SHOW_AFTER;
        if (visible !== this.state.visible) this.setState({ visible });
    }

    scrollToTop = () => {
        const scroller = document.getElementById('root');
        if (scroller && scroller.scrollTo) {
            scroller.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    render() {
        const { visible } = this.state;
        return (
            <button
                type='button'
                className='scroll_top_button'
                aria-label='Наверх'
                title='Наверх'
                onClick={this.scrollToTop}
                style={{
                    position: 'fixed',
                    right: 24,
                    bottom: 24,
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    border: '2px solid #1a1a1a',
                    background: '#ffffff',
                    color: '#1a1a1a',
                    fontSize: 22,
                    lineHeight: 1,
                    cursor: 'pointer',
                    zIndex: 999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
                    opacity: visible ? 1 : 0,
                    pointerEvents: visible ? 'auto' : 'none',
                    transition: 'opacity 0.3s ease',
                }}
            >
                ↑
            </button>
        );
    }
}